import styled, { css } from "styled-components";
import {
  Space,
  Input,
  Typography,
  DatePicker,
  Select,
  Tag,
  Image,
  Button,
  Upload,
  InputNumber,
  Form,
  TimePicker,
} from "antd";
import { CloseCircleFilled } from "@ant-design/icons";

const { Dragger } = Upload;
const { TextArea } = Input;

interface StyledInputFieldProps {
  isEditable?: boolean;
}

export const StyledInputField = styled(Input)<StyledInputFieldProps>`
  width: 100%;
  font-size: 14px;
  padding: 0.75rem 1rem;
  outline: none;
  box-shadow: 0px 1px 2px 0px #1018280d;
  pointer-events: ${(props) => (props.isEditable ? "auto" : "none")};

  &.ant-input-disabled {
    background: initial;
  }
`;

export const StyledPasswordInputField = styled(
  Input.Password
)<StyledInputFieldProps>`
  width: 100%;
  font-size: 14px;
  padding: 0.75rem 1rem;
  outline: none;
  box-shadow: 0px 1px 2px 0px #1018280d;
  pointer-events: ${(props) => (props.isEditable ? "auto" : "none")};

  &.ant-input-disabled {
    background: initial;
  }
`;

export const StyledFormItemField = styled(Form.Item)`
  margin-bottom: 0;
`;

export const StyledInputWrapper = styled(Space).attrs({
  direction: "vertical",
  size: "small",
})<{ hidden?: boolean }>`
  display: ${(props) => (props.hidden ? "none" : "unset")};

  width: 100%;
  display: flex;
  &.ant-space-gap-col-small {
    width: 100%;
  }
`;
export const StyledTimeInputWrapper = styled(Space).attrs({
  direction: "vertical",
  size: "small",
})<{ hidden?: boolean }>`
  display: ${(props) => (props.hidden ? "none" : "unset")};
  display: flex;
  width: 220px;

  &.ant-space-gap-col-small {
    width: 220px;
  }

  .ant-picker.ant-picker-outlined {
    width: 220px;
  }
  @media (max-width: 1400px) {
    width: unset;

    .ant-picker.ant-picker-outlined {
      width: unset;
    }
    &.ant-space-gap-col-small {
      width: unset;
    }
  }
`;

export const StyledColumnWrapper = styled(Space).attrs({
  direction: "vertical",
  size: "large",
})`
  width: 100%;
`;

export const StyledInputLabel = styled(Typography.Text)`
  font-weight: 400;
  font-size: 14px;
`;

export const StyledTagsSpace = styled(Space).attrs({
  direction: "horizontal",
  size: "small",
})`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;
`;

export const StyledTag = styled(Tag)`
  background: #94a5f233;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: ${(props) => (props.closable ? "unset" : "95px")};
  height: 28px;
  gap: 2px;
  border-radius: 16px;
  border: none;
  color: #808080 !important;
  direction: ltr;
  padding: 0 1rem;
  margin: 0;
`;

export const StyledTagCloseButton = styled(CloseCircleFilled)`
  color: #cfd1de !important;
  font-size: 15px !important;
  background-color: white;
  border-radius: 50%;
  &:hover {
    color: rgb(167, 168, 178) !important;
  }
`;

interface StyledDatePickerProps {
  isEditable?: boolean;
}

export const StyledDatePicker = styled(DatePicker)<StyledDatePickerProps>`
  width: 100%;
  font-size: 14px;
  padding: 0.75rem 1rem;
  outline: none;
  box-shadow: 0px 1px 2px 0px #1018280d;
  pointer-events: ${(props) => (props.isEditable ? "auto" : "none")};

  &.ant-picker-disabled {
    background: initial;
  }

  &:hover {
    background: initial !important;
  }
`;

export const StyledTimePicker = styled(TimePicker)<StyledDatePickerProps>`
  width: 220px;
  font-size: 14px;
  padding: 0.75rem 1rem;
  outline: none;
  box-shadow: 0px 1px 2px 0px #1018280d;
  pointer-events: ${(props) => (props.isEditable ? "auto" : "none")};
  width: fit-content;

  &.ant-picker-disabled {
    background: initial;
  }

  &:hover {
    background: initial !important;
  }
`;

export const StyledVerticalSpace = styled(Space).attrs<{
  isLargeVideoStyle?: boolean;
}>({
  direction: "vertical",
  size: "small",
})<{ isLargeVideoStyle?: boolean }>`
  width: 100%;

  ${(props) =>
    props.isLargeVideoStyle &&
    css`
      & * {
        width: 100% !important;
      }
    `}
`;

interface StyledDropdownFieldProps {
  isEditable?: boolean;
  mode?: "multiple" | "tags";
}

export const StyledDropdownField = styled(Select).attrs({
  direction: "rtl",
  // listHeight: 128,
})<StyledDropdownFieldProps>`
  width: 100%;
  font-size: 14px;
  direction: rtl;

  height: ${(props) => (props.mode === "multiple" ? "unset" : "3rem")};
  outline: none;
  background: #f9f9f9;
  pointer-events: ${(props) => (props.isEditable ? "auto" : "none")};
  box-shadow: ${(props) =>
    props.isEditable ? "0px 1px 2px 0px #1018280d" : "unset"};

  &.ant-select-disabled {
    background: initial;
  }

  .ant-select-item {
    font-size: 14px;
    direction: rtl;
  }

  .ant-select-selector {
    background: #ffffff !important;
    padding: ${(props) => (props.isEditable ? "8px" : "0")};
  }
  .ant-select-selection-overflow {
    gap: 6px;
  }
`;

export const StyledDropdownWithInputField = styled(
  StyledDropdownField
)<StyledDropdownFieldProps>`
  .ant-select-selector {
    padding: 10px 8px;
  }
`;

export const StyledImagePresent = styled(Image)`
  width: 21.75rem;
  height: 11.25rem;
  padding: 12px 16px 12px 16px;
  border-radius: 8px 0px 0px 0px;
  border: 1px 1px 1px 1px;
  opacity: 0px;
`;

export const ImageInputWrapper = styled(Space).attrs<{
  isLargeVideoStyle?: boolean;
}>({
  direction: "horizontal",
  size: "small",
})`
  display: flex;
  align-items: flex-start;
  flex-direction: ${(props) => (props.isLargeVideoStyle ? "column" : "row")};
`;

export const ImageInputColumn = styled(Space).attrs<{
  isLargeVideoStyle?: boolean;
}>({
  size: "small",
})`
  display: flex;
  justify-content: center;
  flex-direction: ${(props) => (props.isLargeVideoStyle ? "row" : "column")};
  & > * {
    width: ${(props) =>
      props.isLargeVideoStyle ? "130px!important" : "inherit"};
  }

  .vsc-controller {
    display: none !important;
  }
`;

export const ImageInpupButton = styled(Button).attrs({
  type: "text",
})`
  direction: rtl;
  display: flex;
  color: black;
  text-align: start;
  font-size: 14px;
  padding: 0.5rem;
  background: transparent !important;
  width: unset !important;

  .ant-btn-icon {
    width: 14px;
    height: 14px;
  }

  .ant-btn-variant-text {
    background: transparent !important;
  }
`;

export const StyledUpload = styled(Upload).attrs({
  listType: "picture-card",
})<StyledDropdownFieldProps & { isImage?: boolean }>`
  width: 21.75rem;
  height: 11.25rem;
  pointer-events: ${(props) => (props.isEditable ? "auto" : "none")};

  .ant-upload-list,
  .ant-upload,
  .ant-upload-list-item-container {
    width: 100% !important;
    height: 100% !important;
  }

  .ant-upload-list-item-container {
    pointer-events: ${(props) => (props.isImage ? "none" : "auto")};
  }
`;

export const StyledTextArea = styled(TextArea)`
  width: 100%;
  font-size: 14px;
  padding: 0.75rem 1rem;
  padding: 12px 16px 12px 16px;
  gap: 8px;
  border-radius: 8px 8px 8px 8px;
  border: 1px 0px 0px 0px;
  opacity: 0px;
  outline: none;

  &.ant-input-disabled {
    background: initial;
  }
`;

export const StyledDraggerPreview = styled(Image)`
  width: 21.75rem;
  height: 11.25rem;
  padding: 12px 16px 12px 16px;
  border-radius: 8px 0px 0px 0px;
  border: 1px 1px 1px 1px;
  opacity: 0px;
`;

export const StyledSearchBar = styled(Input.Search)`
  direction: rtl;
  width: 18.75rem;
  // height: 2rem;
  /* padding: 4px 8px 4px 8px; */
  // gap: 8px;
  border-radius: 6px 0px 0px 0px;
  border: 1px 0px 0px 0px;
  opacity: 0px;

  .ant-btn {
    border-right: none;
  }
`;
export const StyledInputNumberWrapper = styled(Space).attrs({
  direction: "horizontal",
  size: "middle",
})`
  display: flex;
  align-items: center;
  width: 100%;
`;
export const StyledInputNumber = styled(InputNumber).attrs({
  min: 0,
  step: 1,
  controls: false,
})`
  padding: 0;
  width: 2.75rem;
  height: 2.125rem;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #f1f1f1;
  box-shadow: 0px 1px 2px 0px #1018280d;

  input {
    text-align: center;
  }
`;

export const IncrementNumberFieldWrapper = styled(Space).attrs({
  direction: "horizontal",
  size: "small",
})`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const IncrementNumberFieldButton = styled(Button).attrs({
  type: "text",
})`
  padding: 0;
  background-color: transparent;
  border: none;
`;

export const NumberDropdownFieldWrapper = styled(Space).attrs({
  direction: "horizontal",
  size: "small",
})`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const NumberDropdownSelect = styled(Select).attrs({
  listHeight: 128,
  dropdownStyle: { direction: "rtl" },
})`
  height: 2.125rem;
  width: 91px;
  font-size: 14px;
  direction: rtl;
  outline: none;
  border: 1px solid #f1f1f1;
  border-radius: 4px 4px 4px 4px;
  box-shadow: 0px 1px 2px 0px #1018280d;
  // background: #F9F9F9;

  &.ant-select-disabled {
    background: initial;
  }

  .ant-select-item {
    font-size: 14px;
    direction: rtl;
  }

  .ant-select-selector {
    border: none !important;
    background: #ffffff !important;
    padding: 0.75rem 1rem;
  }
`;

export const NumberDropdownInput = styled(Input).attrs({})`
  text-align: center;
  height: 2.125rem;
  width: 2.75rem;
  font-size: 14px;
  padding: 0.75rem 0.5rem;
  outline: none;
  box-shadow: 0px 1px 2px 0px #1018280d;

  &.ant-input-disabled {
    background: initial;
  }

  border: 1px solid #f1f1f1;
`;
